// Endpoints.[controller].[action]

export const Endpoints = {
  login: {
    login: '/api/v1/Login/Login'
  },
  account: {
    getUsers: '/api/v1/account/getUsers',
    getEmployeeTypes: '/api/v1/account/GetEmployeeTypes',
    changePassword: '/api/v1/account/ChangePassword'
  },
  project: {
    getProject: '/api/v1/project/GetProject',
    getProjects: '/api/v1/project/GetProjects',
    getInactiveProjects: '/api/v1/project/GetInactiveProjects',
    getProjectStats: '/api/v1/project/GeProjectStatistics',
    saveProject: '/api/v1/project/SaveProject',
    editProject: '/api/v1/project/EditProject',
    removeProject: '/api/v1/project/RemoveProject',
    uploadFiles: '/api/v1/project/UploadFiles',
    downloadAttachment: '/api/v1/project/DownloadAttachment',
    getProjectAttachments: '/api/v1/project/GetProjectAttachments',
    removeAttachment: '/api/v1/project/RemoveAttachment'
  },
  workbook: {
    getAll: '/api/v1/workbook/GetAll',
    getUserEntries: '/api/v1/workbook/GetUserEntries',
    getProjectEntries: '/api/v1/workbook/GetProjectEntries',
    getUserEntriesFromRange: '/api/v1/workbook/GetUserEntriesFromRange',
    addWorkbookEntry: '/api/v1/workbook/AddWorkbookEntry',
    editWorkbookEntry: '/api/v1/workbook/EditWorkbookEntry',
    removeWorkbookEntry: '/api/v1/workbook/RemoveWorkbookEntry'
  },
  template: {
    getProjectTemplates: '/api/v1/template/GetProjectTemplates',
    getAll: '/api/v1/template/GetAllTemplates'
  },
  announcement: {
    getAll: '/api/v1/announcement/GetAllAnnouncement'
  }
}
